routing.$inject = ['$urlRouterProvider', '$locationProvider', 'IdleProvider', '$httpProvider'];

export default function routing($urlRouterProvider, $locationProvider, IdleProvider, $httpProvider) {
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }
  $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
  $httpProvider.interceptors.push(['$q', '$location', '$window', ($q, $location, $window) => {
    return {
      'request': (config) => {
        config.headers = config.headers || {};
        if ($window.sessionStorage['auth.token']) {
          config.headers.Authorization = 'Bearer ' + $window.sessionStorage['auth.token'];
        }
        return config;
      },
        'responseError': (response) => {
        if (response.status === 401 || response.status === 403) {
          $location.path('/login');
        }
        return $q.reject(response);
      }
    }
  }]);
  $locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise('/');
  IdleProvider.autoResume(false);
  IdleProvider.idle(780);
  IdleProvider.timeout(120);
}



// WEBPACK FOOTER //
// ./src/client/app/core/config.js